import articleDeliveryStatuses from "../../src/api/articles/constants/articleDeliveryStatuses";
import articleDeliveryTypes from "../../src/api/articles/constants/articleDeliveryTypes";
import articleStatuses from "../../src/api/articles/constants/articleStatuses";

export default function createArticleStatus({ api, env }, { article }) {
	const hasLegacyDeliveries = Object.keys(article.channels || {}).some((channelId) => {
		const delivery = article?.channels?.[channelId]?.delivery;
		return (
			delivery?.artifact?.status === articleDeliveryStatuses.DELIVERY_COMPLETED ||
			delivery?.metadata?.status === articleDeliveryStatuses.DELIVERY_COMPLETED
		);
	});

	if (hasLegacyDeliveries) {
		return articleStatuses.READY;
	}

	if (
		Object.values(article.channels || {}).length &&
		Object.values(article?.channels || {}).every(
			(channel) =>
				channel?.deliveryTypes?.length === 1 && channel.deliveryTypes[0] === articleDeliveryTypes.ARTIFACT,
		)
	) {
		return articleStatuses.READY;
	}

	return articleStatuses.DRAFT;
}
